export default __webpack_public_path__ + "static/media/work_ec-history.7e244785.jpg";